import { toast } from "react-toastify";
import { getSnapshotDetails } from "../../app/api/trendSnapshot";
import { uploadImage } from "../../app/api/upload";
import {
  TrendCurveChartData,
  TrendItem,
} from "../../interface/DesignerInterface";
import { BarData, DataNode } from "../../interface/Trends";
import { User } from "../../types";
import { getKeyForS3PdfGeneration } from "../commonUtils";
import {
  filterTrendCurveByDateRange,
  getFactoredTrendCurveResponse,
  shouldPreserveAllCurvePeriods,
} from "../trendSidebarGraphUtils/trendCurveDataUtils";
import { filterArchivedGraphRows } from "../archivedTrends";
import { formatDataForColorAnalysisLevel1 } from "../trendSidebarGraphUtils/colorAnalysisUtils";
import {
  buildTrendCurvesPdfPayload,
  getSnapshotTrendCurveWindowLabel,
} from "../trendSidebarGraphUtils/trendCurvesUtils";

export const getSnapshotGraphsJSONDataS3KeyForPdfDownload = async (
  snapshotId: number,
  user: User | null,
  userId: string
) => {
  if (!snapshotId || !user) return "";
  try {
    const detailsParams = {
      page: 1,
      numberOfTrends: 1,
      postsPerTrend: 1,
    };
    const snapDetails = await getSnapshotDetails(
      snapshotId,
      user,
      detailsParams
    );
    const barGraphData = snapDetails?.data?.barGraphData;
    const trendCurveData = snapDetails?.data?.trendCurveData;
    const genericFilters = snapDetails?.data?.snapshot?.genericFilters;
    const graphsFilters = genericFilters?.graphsFilters;
    const archivedTrendNames = genericFilters?.archivedTrendNames || [];
    const preserveAllPeriods = shouldPreserveAllCurvePeriods(
      genericFilters?.preferenceFilters
    );
    const filterType = graphsFilters?.query_type || "Most Popular";

    //color analysis
    let l1Data = null;
    let l2Data = null;

    //Set L1 Color Analysis Data
    if (snapDetails.data.l1ColorAnalysis) {
      l1Data = snapDetails.data.l1ColorAnalysis as DataNode;
      formatDataForColorAnalysisLevel1(l1Data);
      // Set L2 Color Analysis Data
      const primary_color = graphsFilters?.primary_colour;

      if (snapDetails.data.l2ColorAnalysis && primary_color) {
        l2Data = snapDetails.data.l2ColorAnalysis;
      }
    }
    const colorAnalysisData = { filterType, l1Data, l2Data };
    let overallAnalysisData = null;
    if (barGraphData) {
      overallAnalysisData = {
        filterType,
        overallAnalysisJSON: filterArchivedGraphRows<BarData>(
          barGraphData,
          archivedTrendNames
        ),
      };
    }
    let trendCurvesData = null;
    if (trendCurveData) {
      const curveWindowType = getSnapshotTrendCurveWindowLabel(graphsFilters);
      const filteredTrendCurveData = filterArchivedGraphRows<TrendItem>(
        trendCurveData,
        archivedTrendNames
      );
      const dateFilteredTrendCurveData = filterTrendCurveByDateRange(
        filteredTrendCurveData,
        genericFilters?.preferenceFilters
      );
      const trendCurvesJSON = getFactoredTrendCurveResponse(
        dateFilteredTrendCurveData,
        curveWindowType,
        undefined,
        preserveAllPeriods
      ) as TrendCurveChartData;

      trendCurvesData = buildTrendCurvesPdfPayload(
        curveWindowType,
        trendCurvesJSON,
        dateFilteredTrendCurveData
      );
    }
    const payloadJsonForS3 = {
      colorAnalysisData,
      overallAnalysisData,
      trendCurvesData,
    };
    const fileName = Number(new Date());
    const key = getKeyForS3PdfGeneration(userId, fileName);
    const response = await uploadImage(key, JSON.stringify(payloadJsonForS3));
    return response.key;
  } catch (error) {
    console.error("Error while generating s3 for snapshot graphs", error, user);
    toast.error("Error while generating s3 for snapshot graphs", {
      hideProgressBar: true,
    });
    return "";
  }
};
